const CounterItemModel = {
  position: 1,
  countFrom: 0,
  countTo: 100,
  color: '',
  label: { pl: '' },
};

export default CounterItemModel;
